export default __webpack_public_path__ + "static/dreamBuoy-b5742aa45e2e87fafaa37e81018363ae.svg";